
const isOpenFin = !!window['fin'];

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  isOpenFin
};
